import { DEFAULT_HEADERS } from './constants.service';
import http from './http';

/**
 * Track an event for the admin dashboard
 * Note: This is a low-level service function. Consider using the trackEvent helper
 * from '@/helpers/trackEvent' instead, which handles user context automatically.
 *
 * @param {string} kb_id - The knowledge base ID
 * @param {string} event_name - The name of the event to track
 * @param {Object} event_data - Additional event data properties (should include kb_id)
 * @returns {Promise} The HTTP response from the post request
 */
export const trackEvent = async (kb_id, event_name, event_data = {}) => {
  return http.post(
    `${import.meta.env.VITE_APP_BASE_API}admin-dashboard/track-event/kb/${kb_id}`,
    {
      event: event_name,
      event_data: event_data
    },
    {
      headers: DEFAULT_HEADERS
    }
  );
};
